module.exports = __webpack_public_path__ + "img/homeIcon12.2ed53f1d.png";